import { availableOriginsNamensType } from "../components/shared/filter-fields/models/filter-field.model";

export class FilterFieldsUtil {

  /**
   * Retorna a opção de preAprovado ('S', 'A', 'N', ou undefined) com base nos filtros selecionados.
   * - "Pré Aprovação: Pré Aprovado" => 'S'
   * - "Pré Aprovação: Necessita Análise" => 'A'
   * - "Pré Aprovação: Não Solicitado" => 'N'
   * - Qualquer outro caso => undefined
   */
  static getPreAprovadoFromFilters(currentFilters: string[]): 'S' | 'N' | 'null' | undefined {
    if (!currentFilters) return undefined;
    if (currentFilters.includes('Pré Aprovação: Pré Aprovado')) return 'S';
    if (currentFilters.includes('Pré Aprovação: Necessita Análise')) return 'N';
    if (currentFilters.includes('Pré Aprovação: Não Solicitado')) return 'null';
    return undefined;
  }

  /**
   * Retorna a opção de renovaMais ('S', 'N', ou undefined) com base nos filtros selecionados.
   * - "Renova+: Sim" => 'S'
   * - "Renova+: Não" => 'N'
   * - Qualquer outro caso => undefined
   */
  static getRenovaMaisFromFilters(currentFilters: string[]): 'S' | 'N' | undefined {
    if (!currentFilters) return undefined;
    if (currentFilters.includes('Renova+: Sim')) return 'S';
    if (currentFilters.includes('Renova+: Não')) return 'N';
    return undefined;
  }

  /**
   * Retorna a opção de origem ('Sempre Novo', 'Ofertas VW', 'Campanha', ou undefined) com base nos filtros selecionados.
   * - "Origem: Sempre Novo" => 'Sempre Novo'
   * - "Origem: Ofertas VW" => 'Ofertas VW'
   * - "Origem: Campanha" => 'Campanha'
   * - Qualquer outro caso => undefined
   */
  static getOrigemFromFilters(currentFilters: string[]): availableOriginsNamensType | undefined {
    if (!currentFilters) return undefined;
    if (currentFilters.includes('Origem: Sempre Novo')) return 'Sempre Novo';
    if (currentFilters.includes('Origem: Ofertas VW')) return 'Ofertas VW';
    if (currentFilters.includes('Origem: S&D PF')) return 'S&D PF';
    if (currentFilters.includes('Origem: S&D PJ')) return 'S&D PJ';
    if (currentFilters.includes('Origem: S&D CONCESSIONARIOS')) return 'S&D CONCESSIONARIOS';
    if (currentFilters.includes('Origem: S&D COBRANDED')) return 'S&D COBRANDED';
    return undefined;
  }
}




